export default {
  AddToHomeScreen: 'نصب نسخه قابل حمل',
  notFound: 'کاربر یافت نشد',
  loginFailed: 'نام کاربری یا رمز عبور صحیح نمی باشد',
  invalidPassword: 'رمز عبور صحیح نیست',
  emailNotFound: 'ایمیل یافت نشد',
  userNotFound: 'کاربر پیدا نشد',
  invalidToken: 'توکن نامعتبر می باشد',
  phoneNumberNotVerified: 'شماره همراه شما تایید نشده است',
  emailNotVerified: 'ایمیل شما تایید نشده است',
  ChangePassword: 'ویرایش رمز عبور',
  Login: 'ورود',
  Logout: 'خروج',
  Register: 'ثبت نام',
  SignInToYourAccount: 'وارد حساب کاربری خود شوید',
  Email: 'ایمیل',
  Username: 'نام کاربری',
  Password: 'رمز عبور',
  HaveYouForgotPassword: 'رمز عبورتان را فراموش کرده اید؟',
  RememberPassword: 'یادآوری رمز عبور',
  ForgotPassword: 'فراموشی رمز عبور',
  ResetPassword: 'تنظیم مجدد رمز عبور',
  Account: 'حساب کاربری',
  Profile: 'اطلاعات شخصی',
  SignUp: 'ثبت نام',
  EnterEmail: 'لطفا ایمیل خود را وارد کنید',
  EnterNewPassword: 'لطفا رمز عبور جدید را وارد کنید',
  ResetPasswordEmailSentTo: 'ایمیل بازیابی به آدرس "{email}" ارسال گردید.',
  PleaseCheckYourInbox: 'لطفا ایمیل تان را چک کنید.',
  AndMaybeYourSpamFolder: 'و احتمالا فولدر اسپم!',
  SignUpMessage: 'هنوز ثبت نام نکرده اید؟ روی دکمه زیر کلیک کنید.',
  RegisterNow: 'هم اکنون ثبت نام کنید!',
  CurrentPassword: 'رمز عبور کنونی',
  NationalId: 'کد ملی',
  NewPassword: 'رمز عبور جدید',
  ConfirmPassword: 'تکرار رمز عبور جدید',
  RepeatPassword: 'تکرار رمز عبور',
  NewPasswordAndConfirmDontMatch: 'رمز عبور جدید و تکرار آن یکسان نیستند',
  YourPasswordHasChanged: 'رمز عبور شما تغییر کرد',
  UseSocialToLogin: 'با حساب {provider} وارد شوید',
  google: 'گوگل',
  facebook: 'فیسبوک',
  CreateAccount: 'ایجاد حساب کاربری',
  CreateYourAccount: 'حساب کاربری خود را ایجاد کنید',
  UseYourSocialAcountToRegister:
    'از حساب کاربری شبکه های اجتماعی خود برای ثبت نام استفاده کنید.',
  UsernameAlreadyTaken:
    'این نام کاربری قبلا ثبت شده است. لطفا یک نام کاربری دیگر انتخاب کنید.',
  RegisterSuccessful: 'شما با موفقیت ثبت نام کردید',
  PasswordAndItsRepeatDoesntMatch: 'رمز عبور و تکرار آن یکسان نیست.',

  // refactored
  loginRegister: 'ورود | ثبت نام',
  login: 'ورود',
  register: 'ثبت نام',
  loginWithPassword: 'ورود با رمز عبور',
  otpLogin: 'ورود با رمز یکبار مصرف',
  twoStepVerification: 'تایید دو مرحله ای',
  loginDescription_html: 'سلام!<br/>لطفا شماره موبایل خود را وارد کنید',
  pleaseEnterYourPassword: 'لطفا رمز عبور خود را وارد کنید',
  forgotPassword: 'فراموشی رمز عبور',
  userIsNotAdmin: 'فقط مدیران قادر به ورود می باشند',
  otpLoginTemplate_html:
    'کد تایید برای شماره <b>{mobile}</b> پیامک شد.<br/>لطفا کد تایید را وارد کنید',
  verificationCode: 'کد تایید',
  otpCountdownTemplate: '{minutes}:{seconds} مانده تا دریافت مجدد کد',
  resendOtpCode: 'ارسال مجدد کد تایید',
  password: 'رمز عبور',
  noUserFoundWithThisMobile: 'کاربری با این موبایل یافت نشد! ',
  forgotPasswordDescription:
    'برای تغییر رمز عبور، شماره موبایل خود را وارد کنید',
  resetPassword: 'بازنشانی رمز عبور',
  newPassword: 'رمز عبور جدید',
  newPassword2: 'تکرار رمز عبور جدید'
}
